module.exports = __webpack_public_path__ + "static/media/2_0001sCapital-One.601f918b.png";